export const equipment = {
  main: "Equipment",
};
